module.exports = __webpack_public_path__ + "img/banner.8199b9fc.png";